import { FunctionComponent, memo } from "react";

import { IProps } from "./sentiment-icon.types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getSentimentIconProps } from "./sentiment-icon.utilities";
import "./sentiment-icon.scss";

/**
 * An icon representing the sentiment being expressed.
 * @param props.sentiment      The sentiment being expressed.
 * @param fontAwesomeIconProps Any other props to pass to the icon.
 * @returns                    An icon that matches the sentiment.
 */
const SentimentIcon: FunctionComponent<IProps> = ({ sentiment, ...fontAwesomeIconProps }) => (
    <span className="sentiment-icon">
        <FontAwesomeIcon
            size="lg"
            {...fontAwesomeIconProps}
            title={sentiment}
            name={sentiment}
            {...getSentimentIconProps(sentiment)}
        />
    </span>
);

export default memo(SentimentIcon);
